export const FETCH_FORMULAS_INDEXS = "FETCH_FORMULAS_INDEXS";
export const FETCH_FORMULAS = "FETCH_FORMULAS";
export const FETCH_FORMULAS_UPDATE = "FETCH_FORMULAS_UPDATE";
export const FETCH_FORMULAS_SUCCESS = "FETCH_FORMULAS_SUCCESS";
export const FETCH_FORMULAS_FAILED = "FETCH_FORMULAS_FAILED";

export const FETCH_ADDERS = "FETCH_ADDERS";
export const FETCH_ADDERS_UPDATE = "FETCH_ADDERS_UPDATE";
export const FETCH_ADDERS_SUCCESS = "FETCH_ADDERS_SUCCESS";
export const FETCH_ADDERS_FAILED = "FETCH_ADDERS_FAILED";

export const FETCH_BATTERY = "FETCH_BATTERY";
export const FETCH_BATTERY_UPDATE = "FETCH_BATTERY_UPDATE";
export const FETCH_BATTERY_SUCCESS = "FETCH_BATTERY_SUCCESS";
export const FETCH_BATTERY_FAILED = "FETCH_BATTERY_FAILED";

export const FETCH_CASH = "FETCH_CASH";
export const FETCH_CASH_UPDATE = "FETCH_CASH_UPDATE";
export const FETCH_CASH_SUCCESS = "FETCH_CASH_SUCCESS";
export const FETCH_CASH_FAILED = "FETCH_CASH_FAILED";

export const FETCH_USER = "FETCH_USER";
export const FETCH_USER_UPDATE = "FETCH_USER_UPDATE";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILED = "FETCH_USER_FAILED";

export const FETCH_FEE = "FETCH_FEE";
export const FETCH_FEE_UPDATE = "FETCH_FEE_UPDATE";
export const FETCH_FEE_SUCCESS = "FETCH_FEE_SUCCESS";
export const FETCH_FEE_FAILED = "FETCH_FEE_FAILED";

export const FETCH_GUIDE = "FETCH_GUIDE";
export const FETCH_GUIDE_UPDATE = "FETCH_GUIDE_UPDATE";
export const FETCH_GUIDE_SUCCESS = "FETCH_GUIDE_SUCCESS";
export const FETCH_GUIDE_FAILED = "FETCH_GUIDE_FAILED";

export const FETCH_SELFGEN = "FETCH_SELFGEN";
export const FETCH_SELFGEN_UPDATE = "FETCH_SELFGEN_UPDATE";
export const FETCH_SELFGEN_SUCCESS = "FETCH_SELFGEN_SUCCESS";
export const FETCH_SELFGEN_FAILED = "FETCH_SELFGEN_FAILED";

export const FETCH_USERS = "FETCH_USERS";
export const FETCH_USERS_UPDATE = "FETCH_USERS_UPDATE";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILED = "FETCH_USERS_FAILED";

export const FETCH_MODULE = "FETCH_MODULE";
export const FETCH_MODULE_UPDATE = "FETCH_MODULE_UPDATE";
export const FETCH_MODULE_SUCCESS = "FETCH_MODULE_SUCCESS";
export const FETCH_MODULE_FAILED = "FETCH_MODULE_FAILED";

export const FETCH_CALCULATOR = "FETCH_CALCULATOR";
export const FETCH_CALCULATOR_UPDATE = "FETCH_CALCULATOR_UPDATE";
export const FETCH_CALCULATOR_SUCCESS = "FETCH_CALCULATOR_SUCCESS";
export const FETCH_CALCULATOR_FAILED = "FETCH_CALCULATOR_FAILED";

export const USER_SIGN_IN = "USER_SIGN_IN";
export const USER_SIGN_IN_SUCCESS = "USER_SIGN_IN_SUCCESS";
export const USER_SIGN_IN_FAILED = "SIGN_IN_FAILED";
export const USER_SIGN_OUT = "USER_SIGN_OUT";

export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";

export const USER_DELETED = "USER_DELETED";

export const USER_CHECK = "USER_CHECK";
export const USER_CHECKED = "USER_CHECKED";

export const SIDEBAR_OPEN = "SIDEBAR_OPEN";
export const SEARCH_OPEN = "SEARCH_OPEN";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";

export const AUTHENTICATE_SUCCESS = "AUTHENTICATE_SUCCESS";
export const AUTHENTICATE_FAILED = "AUTHENTICATE_FAILED";


